import { doc, getDoc } from 'firebase/firestore';
import { db } from '../helper/firebase.config';

export const shouldShowPricing = async (userId) => {
  try {
    if (!userId) return false;

    const userDocRef = doc(db, 'users', userId);
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      return true;
    }

    const userData = userDocSnap.data();

    // If hasSeenPricing is not set or false, show pricing
    return !userData.subscriptionId;
  } catch (error) {
    console.error('Error checking pricing status:', error);
    throw error;
  }
};

/**
 * Fetches the user's country and state (for India) from their IP address.
 * Returns: { countryCode: string, stateCode: string | null }
 */
export const detectLocationFromIP = async () => {
  try {
    const res = await fetch('https://ipapi.co/json/');
    if (!res.ok) throw new Error('IP lookup failed');
    const data = await res.json();

    const countryCode = data.country_code || '';
    let stateCode = null;

    if (countryCode === 'IN' && data.region) {
      const { getStatesForCountry } = await import('./plan-card/geoData');
      const match = getStatesForCountry('IN').find(
        (s) => s.name.toLowerCase() === data.region.toLowerCase()
      );
      stateCode = match?.code ?? null;
    }

    return { countryCode, stateCode };
  } catch (error) {
    console.warn('Could not detect location from IP:', error.message);
    return { countryCode: '', stateCode: null };
  }
};
